module.exports = __webpack_public_path__ + "static/media/saves-manual-labour.3b9f1aff.png";